import { Helmet } from 'react-helmet-async'
import { Link } from 'react-router-dom'

import { pageUrl } from '../config/site'
import { LOGO_ALT, LOGO_SRC } from '../constants/branding'
import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './about.css'

export default function About() {
  return (
    <div className="about-page">
      <Helmet>
        <title>About Us | Shiny Touch Painting &amp; Renovation</title>
        <meta
          property="og:title"
          content="About Us | Shiny Touch Painting &amp; Renovation"
        />
        <meta
          name="description"
          content="Shiny Touch Painting brings about seven years of experience across strata, commercial, and residential projects in Burnaby and Metro Vancouver."
        />
        <link rel="canonical" href={pageUrl('/about')} />
        <meta property="og:url" content={pageUrl('/about')} />
      </Helmet>
      <Navigation />
      <section className="contact-hero">
        <div className="contact-hero-media">
          <video
            autoPlay
            muted
            loop
            playsInline
            poster="https://images.pexels.com/videos/6474138/pictures/preview-0.jpeg"
            src="https://videos.pexels.com/video-files/6474138/6474138-hd_720_1280_25fps.mp4"
            className="contact-hero-video"
          />
          <div className="contact-hero-overlay" />
        </div>
        <div className="contact-hero-container">
          <div className="contact-hero-content">
            <div className="contact-hero-brand">
              <div className="contact-hero-logo-wrapper">
                <img
                  src={LOGO_SRC}
                  alt={LOGO_ALT}
                  className="contact-hero-logo"
                  width={160}
                  height={160}
                />
              </div>
              <span className="contact-hero-company">
                Shiny Touch Painting &amp; Renovation Ltd
              </span>
            </div>
            <h1 className="hero-title">About Shiny Touch</h1>
            <p className="hero-subtitle">
              About seven years of experience serving strata, commercial, and
              residential clients across Burnaby and Metro Vancouver—with the
              same attention to detail on every job.
            </p>
            <div className="contact-hero-actions">
              <Link to="/request-a-free-quote">
                <div className="btn btn-primary btn-lg">
                  <span>Request a Free Quote</span>
                </div>
              </Link>
              <Link to="/contact">
                <div className="btn btn-lg btn-outline">
                  <span>Contact Us</span>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section id="our-story" className="about-story-section">
        <div className="about-story-inner">
          <h2 className="section-title">Our experience</h2>
          <p className="about-lead">
            We bring <strong>about seven years of experience</strong> working
            with <strong>strata</strong>, <strong>commercial</strong>, and{' '}
            <strong>residential</strong> projects—from touch-ups and repaints to
            larger renovations and ongoing property maintenance.
          </p>
          <p className="about-body">
            Whether you are a homeowner refreshing your space, a business
            updating your premises, or a strata council maintaining common
            property, we focus on clear communication, reliable scheduling, and
            finishes that stand up to real-world use.
          </p>
          <div className="about-pillars">
            <div className="about-pillar">
              <h3 className="about-pillar-title">Strata</h3>
              <p className="about-pillar-text">
                Exterior and common-area work with an eye on bylaws, timelines,
                and minimal disruption for residents.
              </p>
            </div>
            <div className="about-pillar">
              <h3 className="about-pillar-title">Commercial</h3>
              <p className="about-pillar-text">
                Professional interiors and exteriors that reflect your brand
                and keep your workspace presentable for staff and customers.
              </p>
            </div>
            <div className="about-pillar">
              <h3 className="about-pillar-title">Residential</h3>
              <p className="about-pillar-text">
                Interior and exterior painting plus renovation support tailored
                to your home and budget.
              </p>
            </div>
          </div>
          <div className="about-cta-row">
            <Link to="/services">
              <div className="btn btn-primary btn-lg">
                <span>View Services</span>
              </div>
            </Link>
            <Link to="/before-after-gallery">
              <div className="btn btn-lg btn-outline">
                <span>See Our Work</span>
              </div>
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  )
}
